import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_ADD_DIVISION, ROUTE_DIVISION, ROUTE_UPDATE_DIVISION} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Division = lazy(() =>
  import('../../../screens/Division')
    .then(module => ({default: module.Division})));

const AddDivision = lazy(() =>
  import('../../../screens/Division')
    .then(module => ({default: module.AddDivision})));

const UpdateDivision = lazy(() =>
  import('../../../screens/Division')
    .then(module => ({default: module.EditDivision})));

const DivisionNavigation = [
  {
    path: ROUTE_DIVISION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Division />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_DIVISION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddDivision />
      </Suspense>
    ),
  },
  {
    path: ROUTE_UPDATE_DIVISION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <UpdateDivision />
      </Suspense>
    ),
  },
];

export default DivisionNavigation;
